const PHONE_PREFIXES = [
  // ── Europe (prioritized) ──
  { code: 'ES', dial: '+34', name: 'España' },
  { code: 'GB', dial: '+44', name: 'United Kingdom' },
  { code: 'FR', dial: '+33', name: 'France' },
  { code: 'DE', dial: '+49', name: 'Deutschland' },
  { code: 'IT', dial: '+39', name: 'Italia' },
  { code: 'PT', dial: '+351', name: 'Portugal' },
  { code: 'NL', dial: '+31', name: 'Nederland' },
  { code: 'BE', dial: '+32', name: 'België' },
  { code: 'CH', dial: '+41', name: 'Schweiz' },
  { code: 'AT', dial: '+43', name: 'Österreich' },
  { code: 'SE', dial: '+46', name: 'Sverige' },
  { code: 'NO', dial: '+47', name: 'Norge' },
  { code: 'DK', dial: '+45', name: 'Danmark' },
  { code: 'FI', dial: '+358', name: 'Suomi' },
  { code: 'IE', dial: '+353', name: 'Ireland' },
  { code: 'PL', dial: '+48', name: 'Polska' },
  { code: 'CZ', dial: '+420', name: 'Česko' },
  { code: 'SK', dial: '+421', name: 'Slovensko' },
  { code: 'HU', dial: '+36', name: 'Magyarország' },
  { code: 'RO', dial: '+40', name: 'România' },
  { code: 'BG', dial: '+359', name: 'България' },
  { code: 'HR', dial: '+385', name: 'Hrvatska' },
  { code: 'SI', dial: '+386', name: 'Slovenija' },
  { code: 'RS', dial: '+381', name: 'Srbija' },
  { code: 'BA', dial: '+387', name: 'Bosna i Hercegovina' },
  { code: 'ME', dial: '+382', name: 'Crna Gora' },
  { code: 'MK', dial: '+389', name: 'Северна Македонија' },
  { code: 'AL', dial: '+355', name: 'Shqipëria' },
  { code: 'GR', dial: '+30', name: 'Ελλάδα' },
  { code: 'CY', dial: '+357', name: 'Κύπρος' },
  { code: 'MT', dial: '+356', name: 'Malta' },
  { code: 'LU', dial: '+352', name: 'Luxembourg' },
  { code: 'LI', dial: '+423', name: 'Liechtenstein' },
  { code: 'MC', dial: '+377', name: 'Monaco' },
  { code: 'AD', dial: '+376', name: 'Andorra' },
  { code: 'SM', dial: '+378', name: 'San Marino' },
  { code: 'VA', dial: '+379', name: 'Vaticano' },
  { code: 'IS', dial: '+354', name: 'Ísland' },
  { code: 'EE', dial: '+372', name: 'Eesti' },
  { code: 'LV', dial: '+371', name: 'Latvija' },
  { code: 'LT', dial: '+370', name: 'Lietuva' },
  { code: 'UA', dial: '+380', name: 'Україна' },
  { code: 'MD', dial: '+373', name: 'Moldova' },
  { code: 'BY', dial: '+375', name: 'Беларусь' },
  { code: 'RU', dial: '+7', name: 'Россия' },
  { code: 'TR', dial: '+90', name: 'Türkiye' },
  { code: 'GE', dial: '+995', name: 'საქართველო' },
  { code: 'AM', dial: '+374', name: 'Հայաստան' },
  { code: 'AZ', dial: '+994', name: 'Azərbaycan' },

  // ── Americas ──
  { code: 'US', dial: '+1', name: 'USA' },
  { code: 'CA', dial: '+1', name: 'Canada' },
  { code: 'MX', dial: '+52', name: 'México' },
  { code: 'BR', dial: '+55', name: 'Brasil' },
  { code: 'AR', dial: '+54', name: 'Argentina' },
  { code: 'CL', dial: '+56', name: 'Chile' },
  { code: 'CO', dial: '+57', name: 'Colombia' },
  { code: 'PE', dial: '+51', name: 'Perú' },
  { code: 'VE', dial: '+58', name: 'Venezuela' },
  { code: 'EC', dial: '+593', name: 'Ecuador' },
  { code: 'UY', dial: '+598', name: 'Uruguay' },
  { code: 'PY', dial: '+595', name: 'Paraguay' },
  { code: 'BO', dial: '+591', name: 'Bolivia' },
  { code: 'CR', dial: '+506', name: 'Costa Rica' },
  { code: 'PA', dial: '+507', name: 'Panamá' },
  { code: 'GT', dial: '+502', name: 'Guatemala' },
  { code: 'HN', dial: '+504', name: 'Honduras' },
  { code: 'SV', dial: '+503', name: 'El Salvador' },
  { code: 'NI', dial: '+505', name: 'Nicaragua' },
  { code: 'CU', dial: '+53', name: 'Cuba' },
  { code: 'DO', dial: '+1809', name: 'Rep. Dominicana' },
  { code: 'PR', dial: '+1787', name: 'Puerto Rico' },
  { code: 'JM', dial: '+1876', name: 'Jamaica' },
  { code: 'TT', dial: '+1868', name: 'Trinidad & Tobago' },
  { code: 'HT', dial: '+509', name: 'Haïti' },
  { code: 'BZ', dial: '+501', name: 'Belize' },
  { code: 'GY', dial: '+592', name: 'Guyana' },
  { code: 'SR', dial: '+597', name: 'Suriname' },

  // ── Asia ──
  { code: 'CN', dial: '+86', name: 'China' },
  { code: 'JP', dial: '+81', name: 'Japan' },
  { code: 'KR', dial: '+82', name: '한국' },
  { code: 'IN', dial: '+91', name: 'India' },
  { code: 'ID', dial: '+62', name: 'Indonesia' },
  { code: 'TH', dial: '+66', name: 'ไทย' },
  { code: 'VN', dial: '+84', name: 'Việt Nam' },
  { code: 'PH', dial: '+63', name: 'Philippines' },
  { code: 'MY', dial: '+60', name: 'Malaysia' },
  { code: 'SG', dial: '+65', name: 'Singapore' },
  { code: 'HK', dial: '+852', name: 'Hong Kong' },
  { code: 'TW', dial: '+886', name: 'Taiwan' },
  { code: 'PK', dial: '+92', name: 'Pakistan' },
  { code: 'BD', dial: '+880', name: 'Bangladesh' },
  { code: 'LK', dial: '+94', name: 'Sri Lanka' },
  { code: 'NP', dial: '+977', name: 'Nepal' },
  { code: 'MM', dial: '+95', name: 'Myanmar' },
  { code: 'KH', dial: '+855', name: 'Cambodia' },
  { code: 'LA', dial: '+856', name: 'Laos' },
  { code: 'MN', dial: '+976', name: 'Mongolia' },
  { code: 'KZ', dial: '+7', name: 'Kazakhstan' },
  { code: 'UZ', dial: '+998', name: 'Oʻzbekiston' },
  { code: 'TM', dial: '+993', name: 'Türkmenistan' },
  { code: 'KG', dial: '+996', name: 'Кыргызстан' },
  { code: 'TJ', dial: '+992', name: 'Тоҷикистон' },
  { code: 'AF', dial: '+93', name: 'Afghanistan' },

  // ── Middle East ──
  { code: 'SA', dial: '+966', name: 'السعودية' },
  { code: 'AE', dial: '+971', name: 'الإمارات' },
  { code: 'QA', dial: '+974', name: 'قطر' },
  { code: 'KW', dial: '+965', name: 'الكویت' },
  { code: 'BH', dial: '+973', name: 'البحرين' },
  { code: 'OM', dial: '+968', name: 'عمان' },
  { code: 'IL', dial: '+972', name: 'ישראל' },
  { code: 'LB', dial: '+961', name: 'لبنان' },
  { code: 'JO', dial: '+962', name: 'الأردن' },
  { code: 'IQ', dial: '+964', name: 'العراق' },
  { code: 'IR', dial: '+98', name: 'ایران' },
  { code: 'SY', dial: '+963', name: 'سوريا' },
  { code: 'YE', dial: '+967', name: 'اليمن' },
  { code: 'PS', dial: '+970', name: 'فلسطين' },

  // ── Africa ──
  { code: 'ZA', dial: '+27', name: 'South Africa' },
  { code: 'NG', dial: '+234', name: 'Nigeria' },
  { code: 'EG', dial: '+20', name: 'مصر' },
  { code: 'MA', dial: '+212', name: 'المغرب' },
  { code: 'DZ', dial: '+213', name: 'الجزائر' },
  { code: 'TN', dial: '+216', name: 'تونس' },
  { code: 'LY', dial: '+218', name: 'ليبيا' },
  { code: 'KE', dial: '+254', name: 'Kenya' },
  { code: 'ET', dial: '+251', name: 'Ethiopia' },
  { code: 'GH', dial: '+233', name: 'Ghana' },
  { code: 'TZ', dial: '+255', name: 'Tanzania' },
  { code: 'UG', dial: '+256', name: 'Uganda' },
  { code: 'SN', dial: '+221', name: 'Sénégal' },
  { code: 'CI', dial: '+225', name: "Côte d'Ivoire" },
  { code: 'CM', dial: '+237', name: 'Cameroun' },
  { code: 'CD', dial: '+243', name: 'RD Congo' },
  { code: 'MG', dial: '+261', name: 'Madagascar' },
  { code: 'MZ', dial: '+258', name: 'Moçambique' },
  { code: 'AO', dial: '+244', name: 'Angola' },
  { code: 'ZW', dial: '+263', name: 'Zimbabwe' },
  { code: 'RW', dial: '+250', name: 'Rwanda' },
  { code: 'ML', dial: '+223', name: 'Mali' },
  { code: 'BF', dial: '+226', name: 'Burkina Faso' },
  { code: 'NE', dial: '+227', name: 'Niger' },
  { code: 'TD', dial: '+235', name: 'Tchad' },
  { code: 'SD', dial: '+249', name: 'السودان' },
  { code: 'SO', dial: '+252', name: 'Somalia' },
  { code: 'MU', dial: '+230', name: 'Mauritius' },
  { code: 'CV', dial: '+238', name: 'Cabo Verde' },
  { code: 'GQ', dial: '+240', name: 'Guinea Ecuatorial' },
  { code: 'GA', dial: '+241', name: 'Gabon' },
  { code: 'CG', dial: '+242', name: 'Congo' },
  { code: 'BJ', dial: '+229', name: 'Bénin' },
  { code: 'TG', dial: '+228', name: 'Togo' },
  { code: 'SL', dial: '+232', name: 'Sierra Leone' },
  { code: 'LR', dial: '+231', name: 'Liberia' },
  { code: 'GN', dial: '+224', name: 'Guinée' },
  { code: 'GM', dial: '+220', name: 'Gambia' },
  { code: 'MR', dial: '+222', name: 'Mauritanie' },
  { code: 'ER', dial: '+291', name: 'Eritrea' },
  { code: 'DJ', dial: '+253', name: 'Djibouti' },
  { code: 'MW', dial: '+265', name: 'Malawi' },
  { code: 'ZM', dial: '+260', name: 'Zambia' },
  { code: 'BW', dial: '+267', name: 'Botswana' },
  { code: 'NA', dial: '+264', name: 'Namibia' },
  { code: 'SZ', dial: '+268', name: 'Eswatini' },
  { code: 'LS', dial: '+266', name: 'Lesotho' },
  { code: 'SS', dial: '+211', name: 'South Sudan' },
  { code: 'SC', dial: '+248', name: 'Seychelles' },
  { code: 'KM', dial: '+269', name: 'Comores' },
  { code: 'GW', dial: '+245', name: 'Guiné-Bissau' },
  { code: 'ST', dial: '+239', name: 'São Tomé e Príncipe' },
  { code: 'BI', dial: '+257', name: 'Burundi' },
  { code: 'CF', dial: '+236', name: 'Centrafrique' },

  // ── Oceania ──
  { code: 'AU', dial: '+61', name: 'Australia' },
  { code: 'NZ', dial: '+64', name: 'New Zealand' },
  { code: 'FJ', dial: '+679', name: 'Fiji' },
  { code: 'PG', dial: '+675', name: 'Papua New Guinea' },
  { code: 'WS', dial: '+685', name: 'Samoa' },
  { code: 'TO', dial: '+676', name: 'Tonga' },
  { code: 'VU', dial: '+678', name: 'Vanuatu' },

  // ── Caribbean / Other ──
  { code: 'BS', dial: '+1242', name: 'Bahamas' },
  { code: 'BB', dial: '+1246', name: 'Barbados' },
  { code: 'AG', dial: '+1268', name: 'Antigua & Barbuda' },
  { code: 'LC', dial: '+1758', name: 'Saint Lucia' },
  { code: 'GD', dial: '+1473', name: 'Grenada' },
  { code: 'KN', dial: '+1869', name: 'Saint Kitts & Nevis' },
  { code: 'DM', dial: '+1767', name: 'Dominica' },
  { code: 'VC', dial: '+1784', name: 'St. Vincent' },
  { code: 'MV', dial: '+960', name: 'Maldives' },
  { code: 'BN', dial: '+673', name: 'Brunei' },
  { code: 'BT', dial: '+975', name: 'Bhutan' },
  { code: 'TL', dial: '+670', name: 'Timor-Leste' },
];

export default PHONE_PREFIXES;
